import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFittedImage from 'UIComponents/image/UIFittedImage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AttachmentPreviewTile = styled.div.withConfig({
  displayName: "MessagePreviewAttachments__AttachmentPreviewTile",
  componentId: "sc-17tys09-0"
})(["display:flex;justify-content:center;align-items:center;flex-shrink:0;align-self:center;margin-left:10px;width:35px;height:35px;font-size:18px;background-color:white;border-radius:4px;overflow:clip;"]);
const MessagePreviewAttachments = ({
  additionalAttachmentCount = 0,
  hasMissingAttachment = false,
  icon,
  url
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [url ? /*#__PURE__*/_jsx(AttachmentPreviewTile, {
      children: /*#__PURE__*/_jsx(UIFittedImage, {
        fit: "cover",
        src: url
      })
    }) : icon && /*#__PURE__*/_jsx(AttachmentPreviewTile, {
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: icon
      })
    }), hasMissingAttachment ? /*#__PURE__*/_jsx(AttachmentPreviewTile, {
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.attachments.unavailableAttachment"
        }),
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "warning",
          size: "xs"
        })
      })
    }) : additionalAttachmentCount > 0 && /*#__PURE__*/_jsx(AttachmentPreviewTile, {
      children: `+${additionalAttachmentCount}`
    })]
  });
};
MessagePreviewAttachments.displayName = 'MessagePreviewAttachments';
export default MessagePreviewAttachments;